import "./App.css";
import { Toaster } from "react-hot-toast";
import { Layout } from "./Layout/Layout";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserdata, getWhitelabels, setScreenWidth } from "./Redux/Action";
import socketService from "./Utils/socketService";
import { notifyError, notifySuccess } from "./Utils/Helper";
import GetWhitelabelDetail, {  useInitializeWhitelabel } from "./Utils/getWhitelabeldetail";

function App() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state?.Login?.isAuthenticated);
  const userData = useSelector((state) => state?.Login?.userData);
  useInitializeWhitelabel()

  // Fetch user data on auth
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getUserdata());
    }
  }, [isAuthenticated, dispatch]);

  // Set screen width on resize
  useEffect(() => {
    const handleResize = () => {
      dispatch(setScreenWidth(window.innerWidth));
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  // Socket event handlers
  const handleNotification = (data) => {
    dispatch(
      getUserdata({
        payload: {
          kyc_status: data?.kyc_status,
          accountno: data?.accountno,
        },
        updateType: "kyc_status",
      })
    );
  };

  const handleCryptoUpdate = (data) => {
    dispatch(
      getUserdata({
        payload: {
          status: data?.status,
          message: data?.message,
          balance: data?.newBalance,
        },
        updateType: "cryptoStatus",
      })
    );

    if (data?.status === 1) notifySuccess(data?.message);
    else notifyError(data?.message);
  };

  // Socket listeners
  useEffect(() => {
    if (!userData?._id) return;

    const kycEvent = `kyc_new_status_${userData._id}`;
    const cryptoEvent = `crypto_newStatus_${userData._id}_${userData?.pendingCryptoData?.sessionId}`;

    socketService.on(kycEvent, handleNotification);
    if (userData?.pendingCryptoData?.sessionId) {
      socketService.on(cryptoEvent, handleCryptoUpdate);
    }

    return () => {
      socketService.off(kycEvent, handleNotification);
      if (userData?.pendingCryptoData?.sessionId) {
        socketService.off(cryptoEvent, handleCryptoUpdate);
      }
    };
  }, [userData]);

  // Debug log all socket events
  useEffect(() => {
    const logAllSocketEvents = (event, ...args) => {
      console.log(`🛰️ Socket Event Received: ${event}`, ...args);
    };
    socketService.onAny(logAllSocketEvents);
    return () => socketService.offAny(logAllSocketEvents);
  }, []);

  return (
    <>
      <Layout />
      <Toaster />
    </>
  );
}

export default App;
